/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@material-ui/core/";
import React, { useContext, useEffect, useState } from "react";
import { config as url } from "../../../common/config";
import FetchDataContext from "../../../context/fetchData/fetchDataContext";
import useAPI from "../../../hooks/useAPI";
import FormOnCategory from "./FormOnCategory";
import FormOnEditCategory from "./FormOnEditCategory";
import TableOnCategory from "./TableOnCategory";

const Category = (props) => {
	const { getOptionAll } = useAPI();
	const BaseUrl = `${url.category}`;
	const fetchData = useContext(FetchDataContext);
	const { getDataTables, addData, updateData, deleteData, tableRef } =
		fetchData;
	const [state, setState] = useState({
		openAdd: false,
		pageSize: 5,
	});
	const { openAdd, pageSize } = state;
	const [openEdit, setOpenEdit] = useState(false);
	const [data, setData] = useState();
	const [option, setOption] = useState(null);

	const handleOpenCloseFormAdd = () => {
		setState({ ...state, openAdd: !openAdd });
	};

	const handleOpenCloseFormEdit = (params) => {
		setOpenEdit(!openEdit);
		setData(params);
	};

	const fetchAPI = async (action, data) => {
		let result;
		if (action === "add")
			result = await addData(
				`${BaseUrl}/add_kategori`,
				data,
				handleOpenCloseFormAdd
			);
		if (action === "edit")
			result = await updateData(
				`${BaseUrl}/edit_kategori?id=${data.id}`,
				data,
				handleOpenCloseFormEdit
			);

		if (action === "delete")
			result = await deleteData(
				`${BaseUrl}/delete_kategori?id=${data.id}`,
				data.nama,
				{
					status: false,
				}
			);
		return result;
	};

	const handleOption = async () => {
		const res = await getOptionAll(`${url.optionMaster}/layanan`, "categoty");
		setOption(res.data);
		return res.data;
	};

	useEffect(() => {
		handleOption();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Grid direction="column" alignItems="center">
			<TableOnCategory
				getDataTables={getDataTables}
				BaseUrl={BaseUrl}
				fetchAPI={fetchAPI}
				pageSize={pageSize}
				tableRef={tableRef}
				modalAdd={handleOpenCloseFormAdd}
				modalEdit={handleOpenCloseFormEdit}
			/>
			<FormOnCategory
				open={openAdd}
				fetchAPI={fetchAPI}
				handleClose={handleOpenCloseFormAdd}
				option={option}
			/>
			<FormOnEditCategory
				open={openEdit}
				editData={data}
				handleClose={handleOpenCloseFormEdit}
				fetchAPI={fetchAPI}
			/>
		</Grid>
	);
};
export default Category;
